import axios, { AxiosInstance, AxiosResponse } from "axios";
import { getJwt } from "../cookie-helpers";

/**
 * AuthService - Creates an Axios instance with auth API configuration
 * @class AuthService
 */
class AuthService {
  private static instance: AuthService;
  private api: AxiosInstance;

  private constructor() {
    this.api = axios.create({
      baseURL: process.env.REACT_APP_AUTH_API_URL,
      headers: {
        "Content-Type": "application/json",
      },
    });

    this.addBearerTokenInterceptor(this.api);
  }

  public static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  public getAxiosInstance(): AxiosInstance {
    return this.api;
  }

  private addBearerTokenInterceptor(api: AxiosInstance): void {
    api.interceptors.request.use((config) => {
      config.headers["Authorization"] = "Bearer " + getJwt();
      return config;
    });
  }

  public getUserInfo(): Promise<AxiosResponse> {
    return this.api.get("/userinfo");
  }

  public async getUserInfoData(): Promise<any> {
    try {
      const response = await this.getUserInfo();
      return response.data;
    } catch (error) {
      console.error("Error fetching user info:", error);
      throw error;
    }
  }
}

// Export a singleton instance
export default AuthService;
